export const selectIsGmailOutlookApp = (state) => state.gmailOutlookApp.isGmailOutlookApp;
